module.exports = __webpack_public_path__ + "img/fig20.12be424e.jpg";